import { useAtom } from "jotai";
import { notification } from "antd";
import EvaluacionService from "services/EvaluacionService";
import {
	evaluacionPendienteSeleccionadaAtom,
	visibleModalEvaluacionConductorAtom
} from "../../BandejaEvaluacionStorage";
import usePreguntasPuntualidad from "./usePreguntasPuntualidad";
import usePreguntasComunicacionReportes from "./usePreguntasComunicacionReportes";
import usePreguntasResponsabilidadManejoVehiculo from "./usePreguntasResponsabilidadManejoVehiculo";
import usePreguntasActitudTrabajoEquipo from "./usePreguntasActitudTrabajoEquipo";
import usePreguntasPredisposicion from "./usePreguntasPredisposicion";
import usePreguntasImagenRepresentacionEmpresa from "./usePreguntasImagenRepresentacionEmpresa";
import useObservacionResultado from "./useObservacionResultado";
import useResultadoEvaluacionConductor from "./useResultadoEvaluacionConductor";
import usePlanAccion from "./usePlanAccion";
import useRenovacion from "./useRenovacion";
import useModalFirmarEvaluacion from "./useModalFirmarEvaluacion";

const useModalEvaluacionConductor = () => {
	const [visibleModalEvaluacionConductor, setVisibleModalEvaluacionConductor] = useAtom(visibleModalEvaluacionConductorAtom);
	const { mostrarModal: mostrarModalFirmarEvaluacion } = useModalFirmarEvaluacion();
	const [evaluacionPendienteSeleccionada, setEvaluacionPendienteSeleccionada] = useAtom(
		evaluacionPendienteSeleccionadaAtom
	);
	
	const { frmPreguntas: frmPreguntasPuntualidad } = usePreguntasPuntualidad();
	const { frmPreguntas: frmPreguntasComunicacionReportes } = usePreguntasComunicacionReportes();
	const { frmPreguntas: frmPreguntasResponsabilidadManejoVehiculo } = usePreguntasResponsabilidadManejoVehiculo();
	const { frmPreguntas: frmPreguntasActitudTrabajoEquipo } = usePreguntasActitudTrabajoEquipo();
	const { frmPreguntas: frmPreguntasImagenRepresentacionEmpresa } = usePreguntasImagenRepresentacionEmpresa();
	const { frmPreguntas: frmPreguntasPredisposicion } = usePreguntasPredisposicion();
	const { frmObservacionResultados } = useObservacionResultado();
	const { frmPlanAccion } = usePlanAccion();
	const { frmRenovacion } = useRenovacion();
	const { puntajeTotalEvaluacionConductor } = useResultadoEvaluacionConductor();

	const onClickBtnEnviar = async () => {
		try {
			await frmPreguntasPuntualidad.validateFields();
			await frmPreguntasComunicacionReportes.validateFields();
			await frmPreguntasResponsabilidadManejoVehiculo.validateFields();
			await frmPreguntasActitudTrabajoEquipo.validateFields();
			await frmPreguntasImagenRepresentacionEmpresa.validateFields();
			await frmPreguntasPredisposicion.validateFields();
			await frmObservacionResultados.validateFields();
			await frmPlanAccion.validateFields();
			await frmRenovacion.validateFields();

			const resultado = {
				evaluacionId: evaluacionPendienteSeleccionada.id,
				preguntasPuntualidad: getPreguntas(frmPreguntasPuntualidad),
				preguntasComunicacionReportes: getPreguntas(frmPreguntasComunicacionReportes),
				preguntasResponsabilidadManejoVehiculo: getPreguntas(frmPreguntasResponsabilidadManejoVehiculo),
				preguntasActitudTrabajoEquipo: getPreguntas(frmPreguntasActitudTrabajoEquipo),
				preguntasImagenRepresentacionEmpresa: getPreguntas(frmPreguntasImagenRepresentacionEmpresa),
				preguntasPredisposicion: getPreguntas(frmPreguntasPredisposicion),
				puntajeTotal: puntajeTotalEvaluacionConductor,
				observacion: frmObservacionResultados.getFieldValue("observacion"),
				resultado: getResultado(puntajeTotalEvaluacionConductor),
				planesAccion: frmPlanAccion.getFieldValue("planAccion"),
				renovarContrato: frmRenovacion.getFieldValue("renovarContrato"),
				mesesRenovacion: frmRenovacion.getFieldValue("mesesRenovacion"),
				tipoEvaluacion:"CONDUCTOR"
			};

			setEvaluacionPendienteSeleccionada({ ...evaluacionPendienteSeleccionada, resultado: resultado });
			mostrarModalFirmarEvaluacion();

			console.log("onClickBtnEnviar");
		} catch (error) {
			console.log("errores", error);
		}
	};

	const getPreguntas = (frmPreguntas) => {
		const entradas = Object.entries(frmPreguntas.getFieldsValue());
		let data = entradas.map(([pregunta, puntuacion]) => {
			return {
				pregunta: pregunta,
				puntuacion: puntuacion,
			};
		});
		return data;
	};

	const getResultado = (puntajeTotal) => {
		if (puntajeTotal >= 0 && puntajeTotal <= 50) {
			return "No Apto";
		} else if (puntajeTotal >= 51 && puntajeTotal <= 75) {
			return "Apto con Observaciones (Plan de acción)";
		} else if (puntajeTotal >= 76 && puntajeTotal <= 85) {
			return "Bueno (Plan de Acción opcional)";
		} else if (puntajeTotal >= 86 && puntajeTotal <= 95) {
			return "Destacado";
		} else if (puntajeTotal >= 96 && puntajeTotal <= 100) {
			return "Excelente";
		}
	};

	const mostrarModalConductor = (evaluacion) => {
		setEvaluacionPendienteSeleccionada(evaluacion);
		setVisibleModalEvaluacionConductor(true);
		console.log("evaluacion", evaluacion);
	};

	const ocultarModal = () => {
		setVisibleModalEvaluacionConductor(false);
	};

	return {
		mostrarModalConductor,
		ocultarModal,
		visibleModalEvaluacionConductor,
		onClickBtnEnviar,
	};
};

export default useModalEvaluacionConductor;
